import { getPlatformUrlParts } from '@acl-services/highbond-common';
import { API_VERSION } from '@issuemanager/constants';
import type { OidcSidecarConfig } from '../../services/oidc/sidecar-config';

export const getAppConfig = (
  windowLocation: string,
  sidecar: OidcSidecarConfig | null,
) => {
  if (isLocalhost(windowLocation)) {
    return {
      loginUrl: '',
      tokenRefreshUrl: '',
      sessionUrl: '',
      platformHeaderScriptUrl: '',
      isLocalDev: true,
      apiUrl: getLocalApiUrl(windowLocation),
      directApiUrl: getLocalApiUrl(windowLocation),
      oidcResourceIndicator: undefined,
    };
  }

  const {
    protocol, // https
    // orgSubdomain, // my-org
    region, // ca
    domain, // highbond-gov
    domainSuffix, // -s1/2/3
    tld, // com
    appSubdomain, // issuemanager
  } = getPlatformUrlParts(windowLocation);

  const appSubdomainWithoutRegion = appSubdomain
    .split('-')
    .filter((item) => item !== region)
    .join('-');

  const host = `${domain}${domainSuffix}.${tld}`;
  const apiRegionWithoutUs = region === 'us' || !region ? '' : `-${region}`;

  const absoluteApiUrl = `${protocol}://new-api-${appSubdomainWithoutRegion}${apiRegionWithoutUs}.${host}/${API_VERSION}`;

  return {
    loginUrl: `${protocol}://accounts.${host}/login`,
    tokenRefreshUrl: `${protocol}://accounts.${host}/api/token/refresh`,
    sessionUrl: `${protocol}://authy-api${apiRegionWithoutUs}.${host}/session`,
    platformHeaderScriptUrl: `${protocol}://web-components.${host}/global-navigator/index.js`,
    isLocalDev: false,
    apiUrl: sidecar ? `${sidecar.apiProxyPath}/${API_VERSION}` : absoluteApiUrl,
    directApiUrl: absoluteApiUrl,
    oidcResourceIndicator: sidecar?.resourceIndicator,
  };
};

function isHostDockerInternal(url: string) {
  return url.startsWith('http://host.docker.internal:');
}

function isLocalhost(url: string) {
  return (
    url.startsWith('http://localhost:') ||
    url.startsWith('https://localhost:') ||
    url.startsWith('http://0.0.0.0:') ||
    isHostDockerInternal(url)
  );
}

function getLocalApiUrl(windowLocation: string): string {
  if (isHostDockerInternal(windowLocation)) {
    return 'http://host.docker.internal:3000';
  }
  return 'http://localhost:3000';
}

export function isProductionEnv(windowLocation: string) {
  const { domainSuffix } = getPlatformUrlParts(windowLocation);

  return domainSuffix === '' && !isLocalhost(windowLocation);
}
